import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getAllEarnProjects } from '../api/projects';
import Navbar from '../components/Navbar';

const COLORS = ['#34D399', '#8B5CF6', '#F59E0B', '#3B82F6', '#EC4899', '#10B981'];

export default function Earn() {
    const navigate = useNavigate();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading]   = useState(true);
    const [search, setSearch]     = useState('');

useEffect(() => {
    getAllEarnProjects().then(data => {
        setProjects(Array.isArray(data) ? data : []);
        setLoading(false);
    });
    }, []);

    const filtered = projects.filter(p =>
        p.name.toLowerCase().includes(search.toLowerCase()) ||
        p.ticker.toLowerCase().includes(search.toLowerCase())
    );

    const totalQuests = projects.reduce((acc, p) => acc + (parseInt(p.quest_count) || 0), 0);

    return (
        <div className="app-wrap">
<Helmet>
    {/* Title */}
    <title>Earn Crypto | Complete Quests &amp; Earn Rewards | OnlineICO</title>

    <meta name="description" content="Complete quests for crypto projects and earn token rewards. Join OnlineICO Earn and get rewarded for supporting your favorite blockchain projects." />
    <link rel="canonical" href="https://onlineico.com/earn" />

    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="OnlineICO" />
    <meta property="og:title" content="Earn Crypto | Complete Quests & Earn Rewards | OnlineICO" />
    <meta property="og:description" content="Complete quests for crypto projects and earn token rewards. Join OnlineICO Earn and get rewarded for supporting your favorite blockchain projects." />
    <meta property="og:url" content="https://onlineico.com/earn" />
    <meta property="og:image" content="https://onlineico.com/og-image.png" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@online_ico" />
    <meta name="twitter:title" content="Earn Crypto | Complete Quests & Earn Rewards | OnlineICO" />
    <meta name="twitter:description" content="Complete quests for crypto projects and earn token rewards. Join OnlineICO Earn and get rewarded for supporting your favorite blockchain projects." />
    <meta name="twitter:image" content="https://onlineico.com/og-image.png" />

    {/* Schema.org JSON-LD */}
  <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Earn Crypto | OnlineICO",
        "description": "Complete quests for crypto projects and earn token rewards.",
        "url": "https://onlineico.com/earn",
        "publisher": {
            "@type": "Organization",
            "name": "OnlineICO",
            "url": "https://onlineico.com",
            "logo": "https://onlineico.com/logo_onlineico_v.png"
        }
    })}</script>



</Helmet>
            <Navbar />

            {/* ── HERO ── */}
            <div style={{ maxWidth: '800px', margin: '0 auto', padding: '5rem 1.5rem 3rem', textAlign: 'center' }}>
                <div style={{ display: 'inline-block', background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.3)', borderRadius: '30px', padding: '4px 16px', fontSize: '0.78rem', color: '#F59E0B', fontWeight: '600', marginBottom: '24px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                    ⚡ Earn — Quests
                </div>
                <h1 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: 'clamp(2rem, 5vw, 3rem)', color: '#F1F5F9', lineHeight: 1.15, marginBottom: '20px' }}>
                    Complete quests,{' '}
                    <span style={{ background: 'linear-gradient(135deg, #F59E0B, #EC4899)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                        earn rewards
                    </span>
                </h1>
                <p style={{ color: '#94a3b8', fontSize: '1rem', lineHeight: '1.8', maxWidth: '560px', margin: '0 auto 28px' }}>
                    Each ICO / IDO project creates its own quests. Support the projects you care about and collect their rewards.
                </p>

                {/* Stats */}
                <div style={{ display: 'flex', gap: '24px', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(10,15,30,0.6)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '14px', padding: '12px 24px' }}>
                        <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '1.4rem', color: '#F59E0B' }}>{projects.length}</div>
                        <div style={{ color: '#64748b', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Active projects</div>
                    </div>
                    <div style={{ background: 'rgba(10,15,30,0.6)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '14px', padding: '12px 24px' }}>
                        <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '1.4rem', color: '#34D399' }}>{totalQuests}</div>
                        <div style={{ color: '#64748b', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Available quests</div>
                    </div>
                </div>
            </div>

            {/* ── SEARCH ── */}
            <div style={{ maxWidth: '700px', margin: '0 auto 32px', padding: '0 1.5rem' }}>
                <div style={{ position: 'relative' }}>
                    <span style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8', fontSize: '1rem', pointerEvents: 'none' }}>⌕</span>
                    <input
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        placeholder="Search a project..."
                        style={{ width: '100%', padding: '12px 14px 12px 38px', background: 'rgba(10,15,30,0.6)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '14px', color: '#F1F5F9', fontSize: '0.9rem', fontFamily: 'Inter, sans-serif', outline: 'none', boxSizing: 'border-box' }}
                    />
                </div>
            </div>

            {/* ── GRILLE PROJETS ── */}
            <div style={{ maxWidth: '1000px', margin: '0 auto 6rem', padding: '0 1.5rem' }}>
                {loading ? (
                    <div style={{ textAlign: 'center', color: '#64748b', padding: '4rem' }}>Loading...</div>
                ) : filtered.length === 0 ? (
                    <div style={{ textAlign: 'center', color: '#64748b', padding: '4rem' }}>
                        {projects.length === 0 ? 'No project has created quests yet.' : 'No results for this search.'}
                    </div>
                ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
                        {filtered.map(p => {
                            const color = COLORS[p.id % COLORS.length];
                            const count = parseInt(p.quest_count) || 0;
                            return (
                                <div key={p.id}
                                    onClick={() => navigate(`/earn/${p.slug}`)}
                                    style={{ background: 'rgba(10,15,30,0.6)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '20px', padding: '20px', backdropFilter: 'blur(20px)', cursor: 'pointer', transition: 'border-color 0.2s, transform 0.2s' }}
                                    onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(245,158,11,0.3)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                    onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                                >
                                    {/* Logo + infos */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                                        <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: p.logo_url ? 'transparent' : color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Syne, sans-serif', fontWeight: '800', color: '#0B1120', fontSize: '1rem', flexShrink: 0, overflow: 'hidden' }}>
                                            {p.logo_url
                                                ? <img src={p.logo_url} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                : p.name.substring(0, 2).toUpperCase()}
                                        </div>
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', color: '#F1F5F9', fontSize: '0.95rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.name}</div>
                                            <div style={{ color: '#64748b', fontSize: '0.75rem' }}>{p.ticker} · {p.chain}</div>
                                        </div>
                                    </div>

                                    {/* Badge quêtes + CTA */}
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <div style={{ background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.25)', borderRadius: '20px', padding: '4px 12px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                            <span style={{ color: '#F59E0B', fontWeight: '700', fontSize: '0.85rem' }}>{count}</span>
                                            <span style={{ color: '#94a3b8', fontSize: '0.75rem' }}>quest{count > 1 ? 's' : ''}</span>
                                        </div>
                                        <span style={{ color: '#F59E0B', fontSize: '0.8rem', fontWeight: '600' }}>View quests →</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {!loading && projects.length === 0 && (
                    <div style={{ textAlign: 'center', marginTop: '3rem' }}>
                        <p style={{ color: '#64748b', fontSize: '0.88rem', marginBottom: '16px' }}>Do you have a project? Create your quests from your client space.</p>
                        <button className="vote-btn" onClick={() => navigate('/mon-compte')}>Go to my account</button>
                    </div>
                )}
            </div>
        </div>
    );
}
